import { Alert, Typography } from 'antd';

import {
  useKeywordOverlapWarning,
  type UseKeywordOverlapWarningProps,
} from '../hooks/useKeywordOverlapWarning';
import { useKeywordOverlapWarningEffects } from '../hooks/useKeywordOverlapWarningEffects';

import type { FC } from 'react';

import './KeywordOverlapWarning.scss';

const { Text } = Typography;

// Предупреждение о пересечении кодовых слов с другими роботами (task/11645).
// Сохранение не блокирует.
type KeywordOverlapWarningProps = UseKeywordOverlapWarningProps;

export const KeywordOverlapWarning: FC<KeywordOverlapWarningProps> = (
  props
) => {
  const {
    windowSessionId,
    shownSessionIdRef,
    resetOverlapsView,
    conditionParameters,
    conditionsKey,
    latestConditionsKeyRef,
    overlapCheckGateRef,
    debouncedCheck,
    overlaps,
    hiddenCount,
    isCheckFailed,
  } = useKeywordOverlapWarning(props);

  useKeywordOverlapWarningEffects({
    windowSessionId,
    shownSessionIdRef,
    resetOverlapsView,
    conditionParameters,
    conditionsKey,
    latestConditionsKeyRef,
    overlapCheckGateRef,
    debouncedCheck,
  });

  if (isCheckFailed) {
    return (
      <Text
        type="secondary"
        className="KeywordOverlapWarning__check-failed"
        data-testid="keyword-overlap-check-failed"
      >
        Не удалось проверить пересечения ключевых слов. Сохранить робота можно.
      </Text>
    );
  }

  if (!overlaps.length) {
    return null;
  }

  return (
    <Alert
      type="warning"
      showIcon
      className="KeywordOverlapWarning"
      data-testid="keyword-overlap-warning"
      message="Ключевые слова пересекаются с другими роботами"
      description={
        <>
          <ul className="KeywordOverlapWarning__list">
            {overlaps.map(
              ({ key, message, otherRobotName, otherRobotLocation }) => (
                <li key={key} className="KeywordOverlapWarning__item">
                  <span>{message}</span>
                  <Text
                    type="secondary"
                    className="KeywordOverlapWarning__robot"
                  >
                    Робот «{otherRobotName}»: {otherRobotLocation}
                  </Text>
                </li>
              )
            )}
          </ul>
          {hiddenCount > 0 && (
            <Text
              className="KeywordOverlapWarning__more"
              data-testid="keyword-overlap-more"
            >
              И ещё {hiddenCount}.
            </Text>
          )}
          <Text>
            Сохранить робота можно. Но если лид стоит на этапах обоих роботов,
            на одно сообщение ответят оба.
          </Text>
        </>
      }
    />
  );
};
